module.exports = "/images/sala_viajero_pv03.jpg?4bfccbebef0152b53e20cede381ef3ea";